const Analytics = function(){
    var $ = jQuery;

    jQuery(document).ready(function(){
        /**
         * Sending Page view.
         */
        // ga('send', 'pageview');
        // console.log('send', 'pageview');
        
    
        //// veevartapp.com and gMap iFrame:
        /**
         * Event: view
         * Triggered when document is ready.
         */
        $('iframe').each(function() {
            var src = $(this).attr('src');
            gaSendEvent(getCategory(src), 'Viewed', src, true);

            console.log('Action: Viewed, ', 'Category: ' + getCategory(src), ', src: ' + src, $(this));
        });

        /**
         * Event: Started
         */
        // processIFrameClick()
        attachIframeClickEvent(function(){
            var _this = $(document.activeElement);
            if(!_this.data('started')) {
                var src = _this.attr('src');
                gaSendEvent(getCategory(src), 'Started', src, true);
                _this.data('started', true);

                console.log('Action: Started, ', 'Category: ' + getCategory(src), ', src: ' + src);
            }
        });

        /**
         * Event: Complete
         */
        $('iframe').on('load', iframeLoad);
        function iframeLoad() {
            var _this = $(this);
            if(_this.data('started')){
                var src = _this.attr('src');
                gaSendEvent(getCategory(src), 'Completed', src, true);

                console.log('Action: Completed, ', 'Category: ' + getCategory(src), ', src: ' + src, $(this));
                // Removing the event so that it can't be fired again.
                // $('iframe').off('load', iframeLoad);
            }
        }

        // end

        /**
         * Related posts
         */
        $('section.section--related').on('click', 'a', function(){
            var href = $(this).attr('href');
            gaSendEvent('Related', 'Clicked', href, true);

            console.log('Action: Clicked, ', 'Category: Related, ', 'src: ' + href);
        });
        // end

        /**
         * Social media
         */
        
        $('ul.sharing, .museum-social').on('click', 'li>a', function(){
            var href = $(this).attr('href');
            var position = href.search(/\?u(rl=)?/);
            var action = position != -1 ? 'Share' : 'Click';
            gaSendEvent('Social', action, href, true, 'GA Social', getNetwork(href)); // href.replace(/.*\?u(rl=)?/, '')

            console.log('Action: ' + action, 'Category: Social, ', 'src: ' + href, 'Network: ' + getNetwork(href));
        });

        /**
         * Forms without iFrame
         */
        var forms = $('form');

        forms.find(":input").one( 'change', function() {
            var _this = $(this);
            var _form = _this.closest('form');
            var action = _form.attr('action');
            var pathname = document.location.pathname;
            var category = getCategory(action, 'form');

            if(_form.data('changed')) {
                return;
            }

            if(!action){
                if(_this.attr('id')){
                    action = pathname + '#' + _this.attr('id');
                }
                else if(_this.attr('name')){
                    action = pathname + '#' + _this.attr('name');
                }
            }

            gaSendEvent(category, 'Started', action || pathname, true);
            _form.data('changed', true);
            
            console.log('Action: Started, ', 'Category: ' + category, ', action: ' + action);
        });

        forms.on('submit', function(e){
            var _this = $(this);
            var action = _this.attr('action');
            var pathname = document.location.pathname;
            var category = getCategory(action, 'form');
            
            if(!action){
                if(_this.attr('id')){
                    action = pathname + '#' + _this.attr('id');
                }
                else if(_this.attr('name')){
                    action = pathname + '#' + _this.attr('name');
                }
            }
            
            gaSendEvent(category, 'Completed', action || pathname, true);

            console.log('Action: Completed, ', 'Category: ' + category, ', action: ' + action);
            
        });

    });

    function gaSendEvent(category, action, label, nonInteraction, event, network){

        if ( typeof dataLayer == 'undefined' ) return;

        network = network || '';
        nonInteraction = nonInteraction || false;
        dataLayer.push({
            event: 'event-to-ga',
            eventCategory: category,
            eventAction: action,
            eventLabel: label,
            socialNetwork: network,
            nonInteraction: nonInteraction
        });
    }
  

    function getHostName(url) {
        if(!url) return;
        var match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
        if (match != null && match.length > 2 && typeof match[2] === 'string' && match[2].length > 0) {
            return match[2];
        }
        else {
            return null;
        }
    }

    function getNetwork(src) {
        if(src && src.indexOf('instagram.com') != -1){
            return 'Instagram';
        }
        else if(src && src.indexOf('facebook.com') != -1){
            return 'Facebook';
        }
        else if(src && src.indexOf('twitter.com') != -1){
            return 'Twitter';
        }
        else{
            return getHostName(src) || 'Unknown';
        }
    }
        
    function getCategory(src, type) {
        type = type || 'iFrame';
        if(type == 'form'){
            if(src && src.indexOf('list-manage.com/subscribe') != -1){
                return 'Mailchimp Subscription';
            }
            return 'Form Submission';
        }
        else if(src && src.indexOf('google.com/maps/') != -1){
            return 'Google Map';
        }
        else if(src && src.indexOf('veevartapp.com') != -1){
            var pathname = document.location.pathname;
            if(pathname.search(/^\/tickets\/?$/) != -1){
                return 'Online Tickets';
            }
            else if(pathname.search(/^\/calendar\/?.*/) != -1){
                return 'Calendar RSVPs';
            }
            else if(pathname.search(/^\/support\/.+/) != -1){
                return 'Membership Purchases';
            }
            else if(pathname.search(/^\/support\/?$/) != -1){
                return 'Donations';
            }
            else if(pathname.search(/^\/collection\/?.*/) != -1){
                return 'Membership Purchases';
            }
            return 'Veevart';
        }
        // else if(src && src.indexOf('icamiami-org-develop.branch.icamiami.org') != -1){
        //     return 'Develop Form';
        // }
        else{
            return getHostName(src) || 'iFrame';
        }
    }

};


module.exports = Analytics;